export default "__VITE_ASSET__tSb1jg9v__"